import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import Main from './views/main';
import { adminRoutes, managerRoutes, analystRoutes } from './router';
import Auth from './views/auth';

function App() {
  // @ts-ignore
  const { isLoggedIn, advertiserId, userType, role } = useSelector((state: any) => ({
    isLoggedIn: Boolean(state.auth.accessToken),
    advertiserId: state.auth.advertiserId,
    userType: state.auth.userType,
    role: state.auth.role,
  }));

  const getRoutes = useCallback(() => {
    if (userType === 'ENTERPRISE') {
      return (
        <Main
          routes={advertiserId ? managerRoutes : adminRoutes}
          key={advertiserId ? 'Performance' : 'Admin'}
        />
      );
    }
    if (role === 'ANALYST') return <Main routes={analystRoutes} key="Analyst" />;
    else return <Main routes={managerRoutes} key="Manager" />;
  }, [advertiserId, role, userType]);

  if (!isLoggedIn || (userType !== 'ENTERPRISE' && !advertiserId)) return <Auth />;

  return (
    <>
      <Routes>
        <Route key="login" path="/login" element={<Navigate to="/" />} />
      </Routes>
      {getRoutes()}
    </>
  );
}

export default App;
